import React from 'react';
import { Divider } from '@mui/material';
import { AdminPanelSettings as Admin } from '@mui/icons-material';
import { AUTH_LEVELS } from '../../../auth/Authorized';
import NavDrawerMenu from './NavDrawerMenu';
import DrawerItem from './DrawerItem';

const AdminMenu = ({ isOpen }) => (
  <NavDrawerMenu text="Admin" drawerOpen={isOpen} icon={Admin} authLevel={AUTH_LEVELS.ADMIN}>
    <DrawerItem to="/users" text="User management" authLevel={AUTH_LEVELS.ORG_ADMIN} />
    <DrawerItem to="/building-edit" text="Building management" />
    <Divider />
    <DrawerItem to="/actions-audit" text="Action Log Audit" authLevel={AUTH_LEVELS.SUPER_ADMIN} />
  </NavDrawerMenu>
);

export default AdminMenu;
